import {Routes} from '@angular/router';
import {FilemanagerComponent} from '@pages/filemanager/filemanager/filemanager.component';

export const FILEMANAGER_ROUTES: Routes = [
  {
    path: '',
    component: FilemanagerComponent,
    data: {
      title: 'Filemanager',
      urls: [
        {title: 'Dashboard', url: '/dashboard'},
        {title: 'Filemanager'},
      ],
    }
  }
];
